import {Route} from '@angular/router';

import {UserRouteAccessService} from '../../shared';
import {RegisterComponent} from './register.component';
import {InscriptionReussieComponent} from './inscription-reussie/inscription-reussie.component';
import { PersonnePhysiqueComponent } from './personne-physique/personne-physique.component';
import { PersonneMoraleComponent } from './personne-morale/personne-morale.component';
import { PAGE_TITLE_SUFFIX } from '../../app.constants';

export const registerRoute: Route = {
    path: 'register',
    component: RegisterComponent,
    children: [
        {
            path: 'particulier',
            component: PersonnePhysiqueComponent,
            data: {
                needAuthentication: false,
                pageTitle: `Création de compte particulier${PAGE_TITLE_SUFFIX}`
            },
            canActivate: [UserRouteAccessService]
        },
        {
            path: 'morale',
            component: PersonneMoraleComponent,
            data: {
                needAuthentication: false,
                pageTitle: `Création de compte de personne morale${PAGE_TITLE_SUFFIX}`
            },
            canActivate: [UserRouteAccessService]
        }
    ]
};

export const registerSuccessRoute: Route = {
    path: 'inscription-reussie',
    component: InscriptionReussieComponent,
    data: {
        needAuthentication: false,
        pageTitle: `Inscription réussie${PAGE_TITLE_SUFFIX}`
    },
    canActivate: [UserRouteAccessService]
};



// WEBPACK FOOTER //
// ./src/main/webapp/app/account/register/register.route.ts